// @flow
import ReducerRegistry from 'jitsi/base/redux/ReducerRegistry';
import { UPDATE_CALLEE, UPDATE_CALL_STATUS, SET_CALL_NOTIFICATION_UID, UPDATE_ORGANIZATIONS, UPDATE_IS_LISTENER_ADDED, } from './actionTypes';
/**
 * The redux subtree of this feature.
 */
const STORE_NAME = 'features/call';
const DEFAULT_STATE = {
    status: null,
    callee: null,
    uid: null,
    isListenerAdded: false,
    organizations: [],
};
ReducerRegistry.register(STORE_NAME, (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case UPDATE_CALLEE:
            return {
                ...state,
                callee: action.callee,
            };
        case UPDATE_CALL_STATUS:
            return {
                ...state,
                status: action.status,
            };
        case SET_CALL_NOTIFICATION_UID:
            return {
                ...state,
                uid: action.uid,
            };
        case UPDATE_ORGANIZATIONS:
            return {
                ...state,
                organizations: action.organizations,
            };
        case UPDATE_IS_LISTENER_ADDED:
            return {
                ...state,
                isListenerAdded: action.isListenerAdded,
            };
        default:
            return state;
    }
});
